import React from "react";
import { withNavBars } from "../../HOCs";
import CreateDeliveryMilestoneTemplate from "./createDeliveryMilestoneTemplate";

class CreateDeliveryMilestoneTemplateParent extends React.Component {
    render() {
        return <CreateDeliveryMilestoneTemplate  {...this.props} />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(CreateDeliveryMilestoneTemplateParent, props);
